import React, { FC } from 'react';
import styled from 'styled-components';
import { PastProjectStatus } from 'api/project';
import { LastFiveUpdates } from 'components/organisms/projects/project-list/columns/last-five-updates';
import { BaseCell } from 'components/organisms/timesheets/common/timesheet-table';

const Cell = styled(BaseCell)`
  > div > div {
    display: flex;
  }
`;

interface Props {
  pastProjectStatuses: PastProjectStatus[];
  projectId: number;
  projectName: string;
}

export const LastFiveUpdateCell: FC<Props> = ({
  projectId,
  projectName,
  pastProjectStatuses,
}) => (
  <Cell>
    <LastFiveUpdates
      data={pastProjectStatuses}
      projectId={projectId}
      subTitle={projectName}
    />
  </Cell>
);
